import React from 'react';
import { Navigate } from 'react-router-dom';
import MasterSpareParts from '../components/MasterSpareParts';

const MasterSparePartsPage = ({ user }) => {
  if (!['superadmin', 'admin'].includes(user?.role)) {
    return <Navigate to="/services" replace />;
  }

  return <MasterSpareParts user={user} />;
};

export default MasterSparePartsPage;
